module.exports = __webpack_public_path__ + "static/media/power-image.7a6f81bb.png";